import { ElMessage } from 'element-plus/lib'

export function useMessage () {
  return ElMessage
}
